import script from "./GuestDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestDashboard.vue?vue&type=script&setup=true&lang=js"

import "./GuestDashboard.vue?vue&type=style&index=0&id=69bf3bc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69bf3bc5"]])

export default __exports__